import Button from '@alltrails/shared/denali/components/Button';
import { MEDIA_QUERY_SMALL_DOWN } from 'utils/constants/breakpoints';
import * as styles from './styles/styles.module.scss';

const learnMoreHero = require('../../../../assets/images/careers/careers-footer.jpg');
const learnMoreHeroAvif = require('../../../../assets/images/careers/careers-footer.avif');
const learnMoreHeroWebp = require('../../../../assets/images/careers/careers-footer.webp');
const learnMoreHeroMobile = require('../../../../assets/images/careers/careers-footer-686w.jpg');
const learnMoreHeroMobileAvif = require('../../../../assets/images/careers/careers-footer-686w.avif');
const learnMoreHeroMobileWebp = require('../../../../assets/images/careers/careers-footer-686w.webp');

// Careers page does not need translations
const LearnMore = (): JSX.Element => (
  <div className={styles.container}>
    <picture>
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={learnMoreHeroMobileAvif} type="image/avif" />
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={learnMoreHeroMobileWebp} type="image/webp" />
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={learnMoreHeroMobile} type="image/jpg" />
      <source srcSet={learnMoreHeroAvif} type="image/avif" />
      <source srcSet={learnMoreHeroWebp} type="image/webp" />
      <img src={learnMoreHero} alt="Two people hiking up rocky terrain while holding hands" className={styles.bg} loading="lazy" />
    </picture>
    <div className={styles.content}>
      <h2 className={styles.heading}>We believe nature is what unites us all</h2>
      <div className={styles.learnMore}>Learn more about who we are as a company and what we’re all about.</div>
      <Button
        text="About us"
        linkInfo={{ href: '/about' }}
        onClick={() => {
          /* do nothing - href redirect */
        }}
        testId="careers-about-us"
        variant="primary"
      />
    </div>
  </div>
);

export default LearnMore;
